// export const GET_INFO = 'https://user.godlyface.com/api/v1/get_contest_information'
// export const SUBMIT_INFO = 'https://user.godlyface.com/api/v1/set_contest_information'

export const GET_INFO = 'https://4y7c2usr0q6k9z8v4b.uploadthetruth.xyz/api/v1/get_contest_information'
export const SUBMIT_INFO = 'https://4y7c2usr0q6k9z8v4b.uploadthetruth.xyz/api/v1/set_contest_information'
